import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { useComplianceAreaQuery } from "@common/hooks/useSelectableItemQueries.ts";

export interface ComplianceAreasFieldProps {
    complianceAreaIds: Array<string>;
    onChange: (complianceAreaIds: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function ComplianceAreasField(props: ComplianceAreasFieldProps) {
    const { translateString } = useTranslation();
    const complianceAreaQuery = useComplianceAreaQuery(!props.isPreview);

    return (
        <DotLegalMultiSelect
            options={complianceAreaQuery.data}
            chosenOptions={props.complianceAreaIds}
            onChange={props.readOnly ? () => {} : props.onChange}
            label={translateString("areas")}
            noOptionsLabel={translateString("noOptions")}
            isLoading={complianceAreaQuery.isLoading && !props.readOnly}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default ComplianceAreasField;
